export const colors = {
  orange600: "var(--sapphire-global-color-secondary-orange-600)",
  orange400: "var(--sapphire-global-color-secondary-orange-400)",
  orange300: "var(--sapphire-global-color-secondary-orange-300)",
  orange200: "var(--sapphire-global-color-secondary-orange-200)",
  orange150: "var(--sapphire-global-color-secondary-orange-150)",
  orange100: "var(--sapphire-global-color-secondary-orange-100)",
  orange75: "var(--sapphire-global-color-secondary-orange-75)",
  orange50: "var(--sapphire-global-color-secondary-orange-50)",
  teal600: "var(--sapphire-global-color-secondary-teal-600)",
  teal500: "var(--sapphire-global-color-secondary-teal-500)",
  teal400: "var(--sapphire-global-color-secondary-teal-400)",
  teal300: "var(--sapphire-global-color-secondary-teal-300)",
  teal200: "var(--sapphire-global-color-secondary-teal-200)",
  teal150: "var(--sapphire-global-color-secondary-teal-150)",
  teal100: "var(--sapphire-global-color-secondary-teal-100)",
  teal75: "var(--sapphire-global-color-secondary-teal-75)",
  teal50: "var(--sapphire-global-color-secondary-teal-50)",
  forestGreen600: "var(--sapphire-global-color-secondary-forest-green-600)",
  forestGreen500: "var(--sapphire-global-color-secondary-forest-green-500)",
  forestGreen400: "var(--sapphire-global-color-secondary-forest-green-400)",
  forestGreen300: "var(--sapphire-global-color-secondary-forest-green-300)",
  forestGreen200: "var(--sapphire-global-color-secondary-forest-green-200)",
  forestGreen150: "var(--sapphire-global-color-secondary-forest-green-150)",
  forestGreen100: "var(--sapphire-global-color-secondary-forest-green-100)",
  forestGreen75: "var(--sapphire-global-color-secondary-forest-green-75)",
  forestGreen50: "var(--sapphire-global-color-secondary-forest-green-50)",
  cobalt600: "var(--sapphire-global-color-secondary-cobalt-600)",
  cobalt500: "var(--sapphire-global-color-secondary-cobalt-500)",
  cobalt400: "var(--sapphire-global-color-secondary-cobalt-400)",
  cobalt300: "var(--sapphire-global-color-secondary-cobalt-300)",
  cobalt200: "var(--sapphire-global-color-secondary-cobalt-200)",
  cobalt150: "var(--sapphire-global-color-secondary-cobalt-150)",
  cobalt100: "var(--sapphire-global-color-secondary-cobalt-100)",
  cobalt75: "var(--sapphire-global-color-secondary-cobalt-75)",
  cobalt50: "var(--sapphire-global-color-secondary-cobalt-50)",
  gray600: "var(--sapphire-global-color-secondary-gray-600)",
  gray500: "var(--sapphire-global-color-secondary-gray-500)",
  gray400: "var(--sapphire-global-color-secondary-gray-400)",
  gray300: "var(--sapphire-global-color-secondary-gray-300)",
  gray200: "var(--sapphire-global-color-secondary-gray-200)",
  gray150: "var(--sapphire-global-color-secondary-gray-150)",
  gray100: "var(--sapphire-global-color-secondary-gray-100)",
  gray75: "var(--sapphire-global-color-secondary-gray-75)",
  gray50: "var(--sapphire-global-color-secondary-gray-50)",
  orchid600: "var(--sapphire-global-color-secondary-orchid-600)",
  orchid500: "var(--sapphire-global-color-secondary-orchid-500)",
  orchid400: "var(--sapphire-global-color-secondary-orchid-400)",
  orchid300: "var(--sapphire-global-color-secondary-orchid-300)",
  orchid200: "var(--sapphire-global-color-secondary-orchid-200)",
  orchid150: "var(--sapphire-global-color-secondary-orchid-150)",
  orchid100: "var(--sapphire-global-color-secondary-orchid-100)",
  orchid75: "var(--sapphire-global-color-secondary-orchid-75)",
  orchid50: "var(--sapphire-global-color-secondary-orchid-50)",
  beige600: "var(--sapphire-global-color-secondary-beige-600)",
  beige500: "var(--sapphire-global-color-secondary-beige-500)",
  beige400: "var(--sapphire-global-color-secondary-beige-400)",
  beige300: "var(--sapphire-global-color-secondary-beige-300)",
  beige200: "var(--sapphire-global-color-secondary-beige-200)",
  beige150: "var(--sapphire-global-color-secondary-beige-150)",
  beige100: "var(--sapphire-global-color-secondary-beige-100)",
  beige75: "var(--sapphire-global-color-secondary-beige-75)",
  beige50: "var(--sapphire-global-color-secondary-beige-50)",
  gold600: "var(--sapphire-global-color-secondary-gold-600)",
  gold500: "var(--sapphire-global-color-secondary-gold-500)",
  gold400: "var(--sapphire-global-color-secondary-gold-400)",
  gold300: "var(--sapphire-global-color-secondary-gold-300)",
  gold200: "var(--sapphire-global-color-secondary-gold-200)",
  gold150: "var(--sapphire-global-color-secondary-gold-150)",
  gold100: "var(--sapphire-global-color-secondary-gold-100)",
  gold75: "var(--sapphire-global-color-secondary-gold-75)",
  gold50: "var(--sapphire-global-color-secondary-gold-50)",
  gold4: "var(--sapphire-global-color-secondary-gold-4)",
  gold3: "var(--sapphire-global-color-secondary-gold-3)",
  gold2: "var(--sapphire-global-color-secondary-gold-2)",
  gold1: "var(--sapphire-global-color-secondary-gold-1)",
  violet600: "var(--sapphire-global-color-secondary-violet-600)",
  violet500: "var(--sapphire-global-color-secondary-violet-500)",
  violet400: "var(--sapphire-global-color-secondary-violet-400)",
  violet300: "var(--sapphire-global-color-secondary-violet-300)",
  violet200: "var(--sapphire-global-color-secondary-violet-200)",
  violet150: "var(--sapphire-global-color-secondary-violet-150)",
  violet100: "var(--sapphire-global-color-secondary-violet-100)",
  violet75: "var(--sapphire-global-color-secondary-violet-75)",
  violet50: "var(--sapphire-global-color-secondary-violet-50)",
  purple600: "var(--sapphire-global-color-secondary-purple-600)",
  purple500: "var(--sapphire-global-color-secondary-purple-500)",
  purple400: "var(--sapphire-global-color-secondary-purple-400)",
  purple300: "var(--sapphire-global-color-secondary-purple-300)",
  purple200: "var(--sapphire-global-color-secondary-purple-200)",
  purple150: "var(--sapphire-global-color-secondary-purple-150)",
  purple100: "var(--sapphire-global-color-secondary-purple-100)",
  purple75: "var(--sapphire-global-color-secondary-purple-75)",
  purple50: "var(--sapphire-global-color-secondary-purple-50)",
  pink600: "var(--sapphire-global-color-secondary-pink-600)",
  pink500: "var(--sapphire-global-color-secondary-pink-500)",
  pink400: "var(--sapphire-global-color-secondary-pink-400)",
  pink300: "var(--sapphire-global-color-secondary-pink-300)",
  pink200: "var(--sapphire-global-color-secondary-pink-200)",
  pink150: "var(--sapphire-global-color-secondary-pink-150)",
  pink100: "var(--sapphire-global-color-secondary-pink-100)",
  pink75: "var(--sapphire-global-color-secondary-pink-75)",
  pink50: "var(--sapphire-global-color-secondary-pink-50)",
  lime600: "var(--sapphire-global-color-secondary-lime-600)",
  lime500: "var(--sapphire-global-color-secondary-lime-500)",
  lime400: "var(--sapphire-global-color-secondary-lime-400)",
  lime300: "var(--sapphire-global-color-secondary-lime-300)",
  lime200: "var(--sapphire-global-color-secondary-lime-200)",
  lime150: "var(--sapphire-global-color-secondary-lime-150)",
  lime100: "var(--sapphire-global-color-secondary-lime-100)",
  lime75: "var(--sapphire-global-color-secondary-lime-75)",
  lime50: "var(--sapphire-global-color-secondary-lime-50)",
  indigo600: "var(--sapphire-global-color-secondary-indigo-600)",
  indigo500: "var(--sapphire-global-color-secondary-indigo-500)",
  indigo400: "var(--sapphire-global-color-secondary-indigo-400)",
  indigo300: "var(--sapphire-global-color-secondary-indigo-300)",
  indigo200: "var(--sapphire-global-color-secondary-indigo-200)",
  indigo150: "var(--sapphire-global-color-secondary-indigo-150)",
  indigo100: "var(--sapphire-global-color-secondary-indigo-100)",
  indigo75: "var(--sapphire-global-color-secondary-indigo-75)",
  indigo50: "var(--sapphire-global-color-secondary-indigo-50)",
  electro600: "var(--sapphire-global-color-secondary-electro-600)",
  electro500: "var(--sapphire-global-color-secondary-electro-500)",
  electro400: "var(--sapphire-global-color-secondary-electro-400)",
  electro300: "var(--sapphire-global-color-secondary-electro-300)",
  electro200: "var(--sapphire-global-color-secondary-electro-200)",
  electro150: "var(--sapphire-global-color-secondary-electro-150)",
  electro100: "var(--sapphire-global-color-secondary-electro-100)",
  electro75: "var(--sapphire-global-color-secondary-electro-75)",
  electro50: "var(--sapphire-global-color-secondary-electro-50)",
  copper600: "var(--sapphire-global-color-secondary-copper-600)",
  copper500: "var(--sapphire-global-color-secondary-copper-500)",
  copper400: "var(--sapphire-global-color-secondary-copper-400)",
  copper300: "var(--sapphire-global-color-secondary-copper-300)",
  copper200: "var(--sapphire-global-color-secondary-copper-200)",
  copper150: "var(--sapphire-global-color-secondary-copper-150)",
  copper100: "var(--sapphire-global-color-secondary-copper-100)",
  copper75: "var(--sapphire-global-color-secondary-copper-75)",
  copper50: "var(--sapphire-global-color-secondary-copper-50)",
  aqua600: "var(--sapphire-global-color-secondary-aqua-600)",
  aqua500: "var(--sapphire-global-color-secondary-aqua-500)",
  aqua400: "var(--sapphire-global-color-secondary-aqua-400)",
  aqua300: "var(--sapphire-global-color-secondary-aqua-300)",
  aqua200: "var(--sapphire-global-color-secondary-aqua-200)",
  aqua150: "var(--sapphire-global-color-secondary-aqua-150)",
  aqua100: "var(--sapphire-global-color-secondary-aqua-100)",
  aqua75: "var(--sapphire-global-color-secondary-aqua-75)",
  aqua50: "var(--sapphire-global-color-secondary-aqua-50)",
  yellow975: "var(--sapphire-global-color-yellow-975)",
  yellow950: "var(--sapphire-global-color-yellow-950)",
  yellow925: "var(--sapphire-global-color-yellow-925)",
  yellow900: "var(--sapphire-global-color-yellow-900)",
  yellow875: "var(--sapphire-global-color-yellow-875)",
  yellow850: "var(--sapphire-global-color-yellow-850)",
  yellow800: "var(--sapphire-global-color-yellow-800)",
  yellow750: "var(--sapphire-global-color-yellow-750)",
  yellow700: "var(--sapphire-global-color-yellow-700)",
  yellow650: "var(--sapphire-global-color-yellow-650)",
  yellow600: "var(--sapphire-global-color-yellow-600)",
  yellow550: "var(--sapphire-global-color-yellow-550)",
  yellow500: "var(--sapphire-global-color-yellow-500)",
  yellow450: "var(--sapphire-global-color-yellow-450)",
  yellow400: "var(--sapphire-global-color-yellow-400)",
  yellow350: "var(--sapphire-global-color-yellow-350)",
  yellow300: "var(--sapphire-global-color-yellow-300)",
  yellow250: "var(--sapphire-global-color-yellow-250)",
  yellow200: "var(--sapphire-global-color-yellow-200)",
  yellow150: "var(--sapphire-global-color-yellow-150)",
  yellow125: "var(--sapphire-global-color-yellow-125)",
  yellow100: "var(--sapphire-global-color-yellow-100)",
  yellow75: "var(--sapphire-global-color-yellow-75)",
  yellow50: "var(--sapphire-global-color-yellow-50)",
  yellow25: "var(--sapphire-global-color-yellow-25)",

  red975: "var(--sapphire-global-color-red-975)",
  red950: "var(--sapphire-global-color-red-950)",
  red925: "var(--sapphire-global-color-red-925)",
  red900: "var(--sapphire-global-color-red-900)",
  red875: "var(--sapphire-global-color-red-875)",
  red850: "var(--sapphire-global-color-red-850)",
  red800: "var(--sapphire-global-color-red-800)",
  red750: "var(--sapphire-global-color-red-750)",
  red700: "var(--sapphire-global-color-red-700)",
  red650: "var(--sapphire-global-color-red-650)",
  red600: "var(--sapphire-global-color-red-600)",
  red550: "var(--sapphire-global-color-red-550)",
  red500: "var(--sapphire-global-color-red-500)",
  red450: "var(--sapphire-global-color-red-450)",
  red400: "var(--sapphire-global-color-red-400)",
  red350: "var(--sapphire-global-color-red-350)",
  red300: "var(--sapphire-global-color-red-300)",
  red250: "var(--sapphire-global-color-red-250)",
  red200: "var(--sapphire-global-color-red-200)",
  red150: "var(--sapphire-global-color-red-150)",
  red125: "var(--sapphire-global-color-red-125)",
  red100: "var(--sapphire-global-color-red-100)",
  red75: "var(--sapphire-global-color-red-75)",
  red50: "var(--sapphire-global-color-red-50)",
  red25: "var(--sapphire-global-color-red-25)",

  green975: "var(--sapphire-global-color-green-975)",
  green950: "var(--sapphire-global-color-green-950)",
  green925: "var(--sapphire-global-color-green-925)",
  green900: "var(--sapphire-global-color-green-900)",
  green875: "var(--sapphire-global-color-green-875)",
  green850: "var(--sapphire-global-color-green-850)",
  green800: "var(--sapphire-global-color-green-800)",
  green750: "var(--sapphire-global-color-green-750)",
  green700: "var(--sapphire-global-color-green-700)",
  green650: "var(--sapphire-global-color-green-650)",
  green600: "var(--sapphire-global-color-green-600)",
  green550: "var(--sapphire-global-color-green-550)",
  green500: "var(--sapphire-global-color-green-500)",
  green450: "var(--sapphire-global-color-green-450)",
  green400: "var(--sapphire-global-color-green-400)",
  green350: "var(--sapphire-global-color-green-350)",
  green300: "var(--sapphire-global-color-green-300)",
  green250: "var(--sapphire-global-color-green-250)",
  green200: "var(--sapphire-global-color-green-200)",
  green150: "var(--sapphire-global-color-green-150)",
  green125: "var(--sapphire-global-color-green-125)",
  green100: "var(--sapphire-global-color-green-100)",
  green75: "var(--sapphire-global-color-green-75)",
  green50: "var(--sapphire-global-color-green-50)",
  green25: "var(--sapphire-global-color-green-25)",

  blue975: "var(--sapphire-global-color-blue-975)",
  blue950: "var(--sapphire-global-color-blue-950)",
  blue925: "var(--sapphire-global-color-blue-925)",
  blue900: "var(--sapphire-global-color-blue-900)",
  blue875: "var(--sapphire-global-color-blue-875)",
  blue850: "var(--sapphire-global-color-blue-850)",
  blue800: "var(--sapphire-global-color-blue-800)",
  blue750: "var(--sapphire-global-color-blue-750)",
  blue700: "var(--sapphire-global-color-blue-700)",
  blue650: "var(--sapphire-global-color-blue-650)",
  blue600: "var(--sapphire-global-color-blue-600)",
  blue550: "var(--sapphire-global-color-blue-550)",
  blue500: "var(--sapphire-global-color-blue-500)",
  blue450: "var(--sapphire-global-color-blue-450)",
  blue400: "var(--sapphire-global-color-blue-400)",
  blue350: "var(--sapphire-global-color-blue-350)",
  blue300: "var(--sapphire-global-color-blue-300)",
  blue250: "var(--sapphire-global-color-blue-250)",
  blue200: "var(--sapphire-global-color-blue-200)",
  blue150: "var(--sapphire-global-color-blue-150)",
  blue125: "var(--sapphire-global-color-blue-125)",
  blue100: "var(--sapphire-global-color-blue-100)",
  blue75: "var(--sapphire-global-color-blue-75)",
  blue50: "var(--sapphire-global-color-blue-50)",
  blue25: "var(--sapphire-global-color-blue-25)",

  blue4: "var(--sapphire-global-color-secondary-blue-4)",
  blue3: "var(--sapphire-global-color-secondary-blue-3)",
  blue2: "var(--sapphire-global-color-secondary-blue-2)",
  blue1: "var(--sapphire-global-color-secondary-blue-1)",

  sapphire97570p: "var(--sapphire-global-color-sapphire-900-70p)",
  sapphire975: "var(--sapphire-global-color-sapphire-975)",
  sapphire950: "var(--sapphire-global-color-sapphire-950)",
  sapphire925: "var(--sapphire-global-color-sapphire-925)",
  sapphire900: "var(--sapphire-global-color-sapphire-900)",
  sapphire875: "var(--sapphire-global-color-sapphire-875)",
  sapphire850: "var(--sapphire-global-color-sapphire-850)",
  sapphire800: "var(--sapphire-global-color-sapphire-800)",
  sapphire750: "var(--sapphire-global-color-sapphire-750)",
  sapphire700: "var(--sapphire-global-color-sapphire-700)",
  sapphire650: "var(--sapphire-global-color-sapphire-650)",
  sapphire600: "var(--sapphire-global-color-sapphire-600)",
  sapphire550: "var(--sapphire-global-color-sapphire-550)",
  sapphire500: "var(--sapphire-global-color-sapphire-500)",
  sapphire450: "var(--sapphire-global-color-sapphire-450)",
  sapphire400: "var(--sapphire-global-color-sapphire-400)",
  sapphire350: "var(--sapphire-global-color-sapphire-350)",
  sapphire300: "var(--sapphire-global-color-sapphire-300)",
  sapphire250: "var(--sapphire-global-color-sapphire-250)",
  sapphire200: "var(--sapphire-global-color-sapphire-200)",
  sapphire150: "var(--sapphire-global-color-sapphire-150)",
  sapphire125: "var(--sapphire-global-color-sapphire-125)",
  sapphire100: "var(--sapphire-global-color-sapphire-100)",
  sapphire75: "var(--sapphire-global-color-sapphire-75)",
  sapphire50: "var(--sapphire-global-color-sapphire-50)",
  sapphire25: "var(--sapphire-global-color-sapphire-25)",

  sand50: "var(--sapphire-global-color-sand-50)",
  sand500: "var(--sapphire-global-color-sand-500)",
  sand600: "var(--sapphire-global-color-sand-600)",
  sand700: "var(--sapphire-global-color-sand-700)",
  sand800: "var(--sapphire-global-color-sand-800)",
  sand900: "var(--sapphire-global-color-sand-900)",
  sand950: "var(--sapphire-global-color-sand-950)",

  transparent: "var(--sapphire-global-color-neutral-transparent)",
  black: "var(--sapphire-global-color-neutral-black)",
  white: "var(--sapphire-global-color-neutral-white)",
};
